import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { FileCodeIcon } from '@hugeicons/core-free-icons'
import { startProCheckout } from '../../../proCheckout'
import ProBadge from '../../common/ProBadge'
import ExportKMZTooltip from '../../common/tooltips/ExportKMZTooltip'

const ExportTargetGroup = ({ uiStore, t, disabled, lgIcon, group }) => {
  const isStarter = uiStore.user && uiStore.user.type === 'starter'
  const isDisabled = disabled && !isStarter

  return (
    <button
      key='btn-export-kmz'
      disabled={isDisabled}
      className={`export-kmz-btn nooutline export-kmz ${isStarter ? 'item-controls__disabled' : ''}`}
      onClick={(e) => {
        e.stopPropagation()
        if (isStarter) {
          startProCheckout({ uiStore, t })
          return
        }
        uiStore.kmlAllShapes = true
        uiStore.kmlFormat = false
        uiStore.openClickTooltip({
          style: {
            width: 360
          },
          position: 'right-start',
          selector: '.tools.popup-menu',
          text: (<ExportKMZTooltip item={group} isTG />)
        })
      }}
    >
      <HugeiconsIcon icon={FileCodeIcon} size={18} className='popup-menu__icon' />
      <span>{t('GLOBAL.EXPORT_KML', { defaultValue: 'Export KML/KMZ' })}</span>
      {isStarter && <ProBadge className='map-settings__pro text-small'>{t('GLOBAL.PRO')}</ProBadge>}
    </button>
  )
}

export default withTranslation()(inject('uiStore')(observer(ExportTargetGroup)))
